import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

// antd
import { Typography, Space } from 'antd'
import { HomeOutlined } from '@ant-design/icons'

// components
import Button from '../../components/button/button'

// routes
import { PRIVATE_ROUTES } from '../../routes'

// slices
import { loginState } from '../login/login.slice'

// styles
import styles from './404.module.css'

const { Title, Text } = Typography

const FoF = () => {
    const navigate = useNavigate()

    const { userProfile } = useSelector(loginState)

    // CHECK ROLE
    function roleCheck() {
        if (userProfile?.isSuperAdmin) {
            return PRIVATE_ROUTES.clients
        } else if (userProfile?.isSupportUser) {
            return `${PRIVATE_ROUTES.projects.projectId(
                userProfile?.activeProjectId?._id
            )}`
        }
    }

    return (
        <div className={styles.fof_page}>
            <div className={styles.fof_container}>
                <div className={styles.fof_content}>
                    <div className={styles.fof_illustration}>
                        <div className={styles.fof_number}>404</div>
                        <div className={styles.fof_glow}></div>
                    </div>
                    <div className={styles.fof_text}>
                        <Title level={1} className={styles.fof_title}>
                            Page Not Found
                        </Title>
                        <Text className={styles.fof_subtitle}>
                            The page you're looking for doesn't exist or has
                            been moved.
                        </Text>
                    </div>
                    <Space size="large" className={styles.fof_actions}>
                        <Button
                            props={{
                                text: 'Go Home',
                                onClick: () =>
                                    navigate(roleCheck(), { replace: true }),
                                icon: <HomeOutlined />,
                                style: {
                                    height: '48px',
                                    padding: '0 32px',
                                    fontSize: '16px',
                                    fontWeight: 500,
                                },
                            }}
                        />
                    </Space>
                </div>
                <div className={styles.fof_background}>
                    <div className={styles.fof_circle}></div>
                    <div className={styles.fof_circle}></div>
                    <div className={styles.fof_circle}></div>
                </div>
            </div>
        </div>
    )
}

export default FoF
